import { withFormik } from 'formik';
import PropTypes from 'prop-types';
import ApplyJobFormLayout from './layout';
import { validateFields } from '../../../../utility/validation';
import {
  APPLY_JOB_FIELD_NAMES,
  getApplyJobFields,
  INITIAL_APPLY_JOB_DATA,
  splitFullName,
} from '../config';
import { api_jobs_public_apply } from '../../../../constants/apiRoutes';
import http from '../../../../utility/http';

const fields = getApplyJobFields();

const ApplyJobForm = withFormik({
  mapPropsToValues: () => ({ ...INITIAL_APPLY_JOB_DATA }),
  enableReinitialize: true,
  validateOnBlur: false,
  validateOnChange: true,
  validateOnMount: true,
  validate: async values => {
    throw await validateFields(fields, values);
  },
  handleSubmit: async (values, { props, setSubmitting }) => {
    const { first_name, last_name } = splitFullName(
      values[APPLY_JOB_FIELD_NAMES.FULL_NAME]
    );

    const formData = new FormData();
    formData.append(APPLY_JOB_FIELD_NAMES.FIRST_NAME, first_name);
    formData.append(APPLY_JOB_FIELD_NAMES.LAST_NAME, last_name);
    formData.append(
      APPLY_JOB_FIELD_NAMES.EMAIL,
      values[APPLY_JOB_FIELD_NAMES.EMAIL].trim()
    );
    formData.append(
      APPLY_JOB_FIELD_NAMES.PHONE,
      values[APPLY_JOB_FIELD_NAMES.PHONE].trim()
    );
    formData.append(
      APPLY_JOB_FIELD_NAMES.CV,
      values[APPLY_JOB_FIELD_NAMES.CV] || ''
    );

    try {
      await http.post(api_jobs_public_apply(props.token), formData);
      props.showSuccessMessage(
        props.translations.successMessages.applicationSubmitted
      );
      props.navigate(`/job/${props.token}`);
    } catch ({ response }) {
      const status = response?.status;
      if (status !== 429) {
        props.showErrorMessage(props.translations.submitError);
      } else {
        props.setRateLimitErrorMessage(props.translations.rateLimitMessage);
      }
    } finally {
      setSubmitting(false);
    }
  },
})(ApplyJobFormLayout);

ApplyJobForm.propTypes = {
  translations: PropTypes.object.isRequired,
  jobTitle: PropTypes.string,
  token: PropTypes.string.isRequired,
  navigate: PropTypes.func.isRequired,
  showErrorMessage: PropTypes.func.isRequired,
  showSuccessMessage: PropTypes.func.isRequired,
  setRateLimitErrorMessage: PropTypes.func.isRequired,
  rateLimitErrorMessage: PropTypes.string,
};

export default ApplyJobForm;
